import './Screen.css';

export function Screen({ children, title, className, ...rest }) {
  return (
    <main
      className={className ? `screen ${className}` : 'screen'}
      role="main"
      {...rest}
    >
      {title && <h1 className="screen__title">{title}</h1>}
      {children}
    </main>
  );
}
